"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayError = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const log_1 = require("common/log");
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    // エラー発生時にcomponentDidCatchより早く呼ばれ、他の処理をブロックする
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.recovoryKey) {
            if (state.recovoryKey !== props.recovoryKey) {
                return Object.assign(Object.assign({}, state), { recovoryKey: props.recovoryKey, hasError: false, error: undefined });
            }
            else {
                return Object.assign(Object.assign({}, state), { recovoryKey: props.recovoryKey });
            }
        }
        return null;
    }
    componentDidCatch(error, info) {
        (() => __awaiter(this, void 0, void 0, function* () {
            if (error.name === "AuthorizationError")
                return;
            if (error.name === "AuthenticationError")
                return;
            const errorObjectExtended = (0, log_1.errorLog)(error, info);
            this.setState((state) => state.hasError
                ? {
                    error: errorObjectExtended,
                }
                : state);
        }))();
    }
    render() {
        var _a;
        if (this.state.error || this.state.hasError) {
            if (((_a = this.state.error) === null || _a === void 0 ? void 0 : _a.name) === "AuthenticationError") {
                return react_1.default.createElement(react_router_dom_1.Navigate, { to: this.props.loginRoute, replace: true });
            }
            return (react_1.default.createElement("div", { style: { padding: "20px" } },
                react_1.default.createElement(exports.DisplayError, { errorInfo: this.state.error })));
        }
        return this.props.children;
    }
}
const DisplayError = ({ errorInfo }) => {
    const { message, code } = (() => {
        if ((errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.name) === "AuthorizationError") {
            return {
                message: "このページを表示する権限がありません。",
                code: undefined,
            };
        }
        else {
            return {
                message: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.userMessage) || "エラーが発生しました。",
                code: errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.logHash,
            };
        }
    })();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { margin: "1em" } }, message),
        code && (react_1.default.createElement("div", { style: { margin: "1em", display: "flex", alignItems: "center" } },
            "\u304A\u554F\u3044\u5408\u308F\u305B\u30B3\u30FC\u30C9:",
            react_1.default.createElement(react_bootstrap_1.InputGroup, { style: { width: "12em", marginLeft: "10px" } },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "url", value: code || "", readOnly: true }),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                        navigator.clipboard.writeText(code || "");
                    } },
                    react_1.default.createElement("i", { className: "mdi mdi-content-copy" })))))));
};
exports.DisplayError = DisplayError;
exports.default = ErrorBoundary;
